module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_6-1259f9e0ff87933a3f3f05203073d187.svg";